import { initHighlightTextDirective } from './highlightText.directive';
import { initClickOutsideDirective } from './clickOutside.directive';
import { initReadOnlyCheckDirective } from './readOnlyCheck.directive';

export const initDirectives = (Vue) => {
  initHighlightTextDirective(Vue);
  initClickOutsideDirective(Vue);
  initReadOnlyCheckDirective(Vue);
};
